//components
import {
  Section,
  Kicker,
  KickerDot,
  SectionTitle,
  SectionLede,
  Grad,
} from '@/containers-ai/SectionHeading';
import { Container } from '@/components/Grid';

//styles
import {
  Header,
  CardsGrid,
  AgentCard,
  CardTitle,
  CardDescription,
  CardReadMore,
} from './TheRestOfTheLineup.styles';

export function TheRestOfTheLineup({ cards, content }) {
  return (
    <Section id="lineup">
      <Container>
        <Header>
          <Kicker>
            <KickerDot />
            {content.kicker}
          </Kicker>
          <SectionTitle style={{ maxWidth: 'none' }}>
            {content.title}
            <Grad>{content.titleHighlight}</Grad>
          </SectionTitle>
          <SectionLede style={{ maxWidth: '870px' }}>
            {content.lede}
          </SectionLede>
        </Header>
        <CardsGrid>
          {cards.map((card) => (
            <AgentCard key={card.slug} href={card.href ?? `/ai/${card.slug}/`}>
              <div>
                <CardTitle>{card.title}</CardTitle>
                <CardDescription>{card.description}</CardDescription>
              </div>
              <CardReadMore>{content.readMoreLabel}</CardReadMore>
            </AgentCard>
          ))}
        </CardsGrid>
      </Container>
    </Section>
  );
}
